import React, { useState } from "react";
import { Offcanvas } from "react-bootstrap";
import "../../assets/css/shorting.css";

const ProductShorting = () => {
  const [show, setShow] = useState(false);
  const [selectedSort, setSelectedSort] = useState("Name: A to Z");

  const handleSelect = (value) => {
    setSelectedSort(value);
    setShow(false);

    // Yahan sorting API/function call karein
    console.log(value);
  };

  return (
    <>
      {/* Sort Icon */}
      <button
        className="sort-btn"
        onClick={() => setShow(true)}
      >
        <i className="bi bi-sort-down"></i>
        Short
      </button>

      {/* Left Drawer */}
      <Offcanvas
        show={show}
        onHide={() => setShow(false)}
        placement="start"
      >
        <Offcanvas.Header closeButton style={{ border:"1px solid #f9f9f9"}}>
          <Offcanvas.Title>Sort By</Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body>
        <div className="short-product"> 
          <div
            className={`sort-option ${
              selectedSort === "Price: Low to High" ? "active" : ""
            }`}
            onClick={() => handleSelect("Price: Low to High")}
          >
            Price: Low to High
          </div>

          <div
            className={`sort-option ${
              selectedSort === "Price: High to Low" ? "active" : ""
            }`}
            onClick={() => handleSelect("Price: High to Low")}
          >
            Price: High to Low
          </div>

          <div
            className={`sort-option ${
              selectedSort === "Name: A to Z" ? "active" : ""
            }`}
            onClick={() => handleSelect("Name: A to Z")}
          >
            Name: A to Z
          </div>

          <div
            className={`sort-option ${
              selectedSort === "Name: Z to A" ? "active" : ""
            }`}
            onClick={() => handleSelect("Name: Z to A")}
          >
            Name: Z to A
          </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};
export default ProductShorting;